import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Famille, FamilleForm } from "../models/families.model";

@Injectable()
export class FamilleService {

  famillesUrl = environment.dns + "api/familles/";

  constructor(private http: HttpClient) { }

  getList(): Observable<Famille[]> {
    return this.http.get<Famille[]>(this.famillesUrl + "list");
  }

  getListBySociety(societyId: number): Observable<Famille[]> {
    return this.http.get<Famille[]>(this.famillesUrl + "list-by-society?societyId=" + societyId);
  }

  getOne(id: number): Observable<Famille> {
    return this.http.get<Famille>(this.famillesUrl + id);
  }

  add(familleForm: FamilleForm): Observable<Famille> {
    return this.http.post<Famille>(this.famillesUrl, familleForm);
  }

  update(familleForm: FamilleForm): Observable<Famille> {
    return this.http.put<Famille>(this.famillesUrl, familleForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.famillesUrl + id);
  }
}
